import React from "react";
import "./Footer.css";
import {
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaTwitter,
  FaInstagram,
} from "react-icons/fa";
import logo from "../../assets/newlogoo.png";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* About Section */}
        <div className="footer-section about">
          <img src={logo} alt="Company Logo" className="footer-logo" />
          <p>
            We are committed to delivering innovative solutions that empower
            businesses to achieve excellence. From strategy to execution, we
            provide end-to-end support for all your digital needs.
          </p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/vs.solutions1/" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/company/nv-software-it-solutions/" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
            <a href="https://x.com/Vijay_soft6664" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
          </div>
        </div>

        {/* Quick Links Section */}
        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Services Section (Updated) */}
        <div className="footer-section services">
          <h3>Services</h3>
          <ul>
            <li><a href="/services">Cloud Solutions</a></li>
            <li><a href="/services">Android Development</a></li>
            <li><a href="/services">Mobile App Development</a></li>
            <li><a href="/services">SaaS Development</a></li>
            <li><a href="/services">UI/UX Design</a></li>
            <li><a href="/services">Web Development</a></li>
            <li><a href="/services">Software Testing</a></li>
            <li><a href="/services">Full Stack Development (Java / Python / MERN)</a></li>
            <li><a href="/services">AI & Machine Learning</a></li>
            <li><a href="/services">DevOps Services</a></li>
            <li><a href="/services">Data Analytics and Visualization</a></li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-section contact">
          <h3>Contact Us</h3>
          <p><FaEnvelope className="contact-icon" /> info@vs-solutions.org</p>
          <p><FaPhoneAlt className="contact-icon" /> +91 7075133814</p>
          <p><FaMapMarkerAlt className="contact-icon" /> Ayyappa Society, Mega Hills, Madhapur, Hyderabad, Telangana 500081, India</p>
          <p><FaMapMarkerAlt className="contact-icon" /> Guntur, Andhra Pradesh, India</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Vijay Software Solutions Private Limited. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
